// @core/api/endpoints/team/approve_team_join_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveTeamJoinApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Approve join application
 * Approves a pending join application. The applicant becomes a team member with the assigned role.
 */
export async function ApproveTeamJoinApplication(
  team_id: string,
  application_id: string,
  data: ApproveTeamJoinApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/join-applications/:application_id/approve`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':application_id', encodeURIComponent(application_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
